import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import styled from 'styled-components';

import logo from 'assets/logo_color.png';

const FooterContainer = styled.div`
    background-color: #242424;
    padding-top: 60px;
    padding-bottom: 60px;
`;

function Footer(): JSX.Element {
    return (
        <FooterContainer>
            <Container>
                <Row className="justify-content-center">
                    <Col xs="auto">
                        <img src={logo} alt="logo" width={150} />
                    </Col>
                </Row>
            </Container>
        </FooterContainer>
    );
}

export default Footer;
